import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { MessageService } from '../message.service';

@Injectable({
  providedIn: 'root'
})
export class HandleUnrecoverableStateService {
  constructor() {
    const updates = inject(SwUpdate);
    const messageService = inject(MessageService);

    updates.unrecoverable.subscribe(event => {
      messageService.alertDialog(
        'An error occurred that we cannot recover from:\n' +
        event.reason +
        '\n\nPlease reload the page.');
    });
  }
}
